import { roomIdToParam } from '@/chat/roomId';
import { ROUTES } from '@/routes/paths';

export interface ActiveChatLocation {
  /** Текущий путь маршрута (напр. `/app/chat`). */
  readonly pathname: string;
  /** Значение параметра `?room=` (компактный id открытой комнаты) или null. */
  readonly roomParam: string | null;
}

/**
 * Виден ли сейчас на экране чат, в который пришло сообщение (и потому звук не нужен): вкладка на экране
 * И открыт раздел «Мои чаты» И выбранная в URL комната совпадает с комнатой сообщения. Вкладка в фоне
 * (document.hidden) означает, что даже открытый чат не виден → возвращаем false, чтобы звук проиграл.
 * Сравниваем комнаты через roomIdToParam — так совпадёт и компактный параметр, и полный room id.
 */
export function isOpenChatVisible(active: ActiveChatLocation, roomId: string): boolean {
  if (typeof document !== 'undefined' && document.hidden) {
    return false;
  }
  if (active.pathname !== ROUTES.APP_CHAT || active.roomParam == null) {
    return false;
  }
  return roomIdToParam(roomId) === roomIdToParam(active.roomParam);
}
